import { Clock,Calendar } from 'lucide-react';
import { useState, useEffect } from 'react';
import API_BASE_URL from '../../config'; 

const CheckinHistory = () => {
  // const checkins = [
  //   { date: 'Today', time: '9:24 AM', location: 'Iron Peak Fitness', duration: '2h 18m' },
  //   { date: 'Oct 13', time: '7:15 PM', location: 'Iron Peak Fitness', duration: '1h 35m' },
  //   { date: 'Oct 12', time: '6:30 AM', location: 'Iron Peak Fitness', duration: '1h 42m' },
  //   { date: 'Oct 10', time: '5:45 PM', location: 'Iron Peak Fitness', duration: '1h 45m' },
  // ];
  const [checkins, setCheckins] = useState([]);

   const fetchCheckInData = async () => {
    try {

      const accessToken = JSON.parse(localStorage.getItem('accessToken') || '{}').token || '';
      const userinfo = JSON.parse(localStorage.getItem("fitscan_user"));

      if (!userinfo || !accessToken) return;

      const activeGymcode = localStorage.getItem('fitscan_active_gymcode') || userinfo.gymcode;
      // 1. Get user stats
      const CheckInDetails = await fetch(`${API_BASE_URL}/api/Attendance/checkinhistory`,{
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          Username: userinfo.username,
          Gymcode: activeGymcode
        }),

      });
      const checkindata = await CheckInDetails.json();
     
      setCheckins(checkindata);

    } catch (err) {
      console.error('Error fetching consistency data:', err);
    }
  };

  useEffect(() => {
    fetchCheckInData(); 
  }, []);




  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Clock size={24} className="text-lime-400" />
        <h1 className="text-2xl font-bold">Check-in History</h1>
      </div>

      <div className="bg-[#181818] border border-[#2b2b2b] rounded-xl overflow-hidden">
        <div className="grid grid-cols-12 bg-[#222] p-4 font-medium">
          <div className="col-span-4 flex items-center">Date</div>
          <div className="col-span-5 flex items-center">Time</div>
          {/* <div className="col-span-4">Location</div> */}
          <div className="col-span-3 flex items-center">Duration</div>
        </div>
        
        <div className="max-h-[500px] overflow-y-auto">
          {checkins.length === 0 && (
            <div className="p-4 text-gray-400 text-center">No check-ins found</div>
          )}

          {checkins.map((checkin, index) => (
            <div key={index} className="grid grid-cols-12 p-4 border-b border-[#2b2b2b] last:border-0 hover:bg-[#222]">
              <div className="col-span-4 flex items-center gap-2">
                <Calendar size={16} className="text-gray-400" />
                {checkin.date}
              </div>
              <div className="col-span-5 flex items-center gap-2">
                  <Clock size={16} className="text-gray-400" />
                  {checkin.time}
              </div>

              {/* <div className="col-span-4 flex items-center gap-2">
                <MapPin size={16} className="text-lime-400" />
                {checkin.location}
              </div> */}
              <div className="col-span-3">
                {/* < size={16} className="text-gray-400" /> */}
                {checkin.duration}
                
                </div>
            </div>
          ))}
        </div>
      </div>

      {/* <button className="border border-lime-400 text-lime-400 hover:bg-lime-400/10 px-4 py-2 rounded-lg">
        View Full History
      </button> */}
    </div>
  );
};

export default CheckinHistory;